import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const EditableContactsForm = styled.div`
    position: relative;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 12px;
    width: 100%;

    @media (max-width: ${wideBreakpoints.mobile}) {
        align-items: stretch;
    }
`;

export const NoWrapText = styled.span`
    display: contents;
    white-space: nowrap;
`;

export const BoldText = styled.span`
    display: contents;
    ${FONTS.H5};
`;

export const BlockWrap = styled.div`
    display: grid;
    flex-wrap: nowrap;
    align-items: flex-start;
    grid-template-columns: 524px min-content;
    column-gap: 12px;
    width: 100%;

    @media (max-width: ${wideBreakpoints.mobile}) {
        grid-template-columns: 1fr;
        row-gap: 24px;
    }   
`;

export const BlockTitle = styled.div`
    ${FONTS.S};
    color: ${COLORS.TextPrimary};
`;
